// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-B":"SHP2B_shp2-detail-B__P_gFZ"};